;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="fd99608a-9979-432f-b771-f68eb46d0833",e._sentryDebugIdIdentifier="sentry-dbid-fd99608a-9979-432f-b771-f68eb46d0833")}catch(e){}}();function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

export { _setPrototypeOf as default };
//# sourceMappingURL=setPrototypeOf.js.map
